import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DashboardLayout from './components/layout/DashboardLayout';

// Auth pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Dashboard pages
import DashboardHome from './pages/DashboardHome';
import SettingsPage from './pages/SettingsPage';
import GroceriesPage from './pages/budget/GroceriesPage';

// Placeholder pages for features not yet built
import { LearnPage, GoalsPage } from './pages/PlaceholderPages';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Protected dashboard routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardLayout><DashboardHome /></DashboardLayout>
            </ProtectedRoute>
          } />

          {/* Budget — Groceries */}
          <Route path="/dashboard/budget/groceries" element={
            <ProtectedRoute>
              <DashboardLayout><GroceriesPage /></DashboardLayout>
            </ProtectedRoute>
          } />

          {/* Education */}
          <Route path="/dashboard/learn" element={
            <ProtectedRoute>
              <DashboardLayout><LearnPage /></DashboardLayout>
            </ProtectedRoute>
          } />

          {/* Goals */}
          <Route path="/dashboard/goals" element={
            <ProtectedRoute>
              <DashboardLayout><GoalsPage /></DashboardLayout>
            </ProtectedRoute>
          } />

          {/* Settings */}
          <Route path="/dashboard/settings" element={
            <ProtectedRoute>
              <DashboardLayout><SettingsPage /></DashboardLayout>
            </ProtectedRoute>
          } />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
